var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChipError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30168 1.70817C4.82576 1.70817 2.00798 4.52596 2.00798 8.00188C2.00798 11.4778 4.82576 14.2956 8.30168 14.2956C11.7776 14.2956 14.5954 11.4778 14.5954 8.00188C14.5954 4.52596 11.7776 1.70817 8.30168 1.70817ZM0.609375 8.00188C0.609375 3.75353 4.05334 0.30957 8.30168 0.30957C12.55 0.30957 15.994 3.75353 15.994 8.00188C15.994 12.2502 12.55 15.6942 8.30168 15.6942C4.05334 15.6942 0.609375 12.2502 0.609375 8.00188Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00798 8.00188C2.00798 4.52596 4.82576 1.70817 8.30168 1.70817C11.7776 1.70817 14.5954 4.52596 14.5954 8.00188C14.5954 11.4778 11.7776 14.2956 8.30168 14.2956C4.82576 14.2956 2.00798 11.4778 2.00798 8.00188Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97843 5.12216L11.1821 10.3258L10.6245 10.8833L5.4209 5.67969L5.97843 5.12216Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4209 10.3252L10.6245 5.12156L11.1821 5.67909L5.97843 10.8827L5.4209 10.3252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipError);
export default __webpack_public_path__ + "static/media/chip__error.20df216c194280ba9af09eb3d7eaa290.svg";
export { ForwardRef as ReactComponent };